export default __webpack_public_path__ + "static/media/a017-market-4.b9f9c7a3.svg";